export const FLYOUT_MODAL_THEME_CART = 'cart';
export const FLYOUT_MODAL_THEME_AOV = 'aov';
export const FLYOUT_MODAL_THEME_REGULAR = 'regular';
export const FLYOUT_MODAL_THEME_TIGHT = 'tight';
export const FLYOUT_MODAL_THEME_GUIDE = 'guide';

export default {
  FLYOUT_MODAL_THEME_CART,
  FLYOUT_MODAL_THEME_AOV,
  FLYOUT_MODAL_THEME_REGULAR,
  FLYOUT_MODAL_THEME_TIGHT,
  FLYOUT_MODAL_THEME_GUIDE,
};
